export const SERVICES = [
  {
    slug: "strategy-consulting",
    label: "Strategy & Consulting",
    shortLabel: "STRATEGY",
    href: "/services/strategy-consulting",
    description: "Roadmaps and positioning your team can execute without vendor spaghetti.",
  },
  {
    slug: "branding-design",
    label: "Branding & Design",
    shortLabel: "BRANDING",
    href: "/services/branding-design",
    description: "Identity and guidelines your site and sales decks can use tomorrow.",
  },
  {
    slug: "digital-marketing",
    label: "Digital Marketing",
    shortLabel: "MARKETING",
    href: "/services/digital-marketing",
    description: "SEO, paid, content, and social from one brief—not four narratives.",
  },
  {
    slug: "web-development",
    label: "Web Development",
    shortLabel: "WEB DEV",
    href: "/services/web-development",
    description: "Fast sites and web apps built to convert, rank, and scale.",
  },
  {
    slug: "mobile-app-development",
    label: "Mobile App Development",
    shortLabel: "MOBILE",
    href: "/services/mobile-app-development",
    description: "iOS, Android, and cross-platform apps from design to store.",
  },
  {
    slug: "ai-solutions",
    label: "AI Solutions",
    shortLabel: "AI",
    href: "/services/ai-solutions",
    description: "Agents and automations that kill copy-paste busywork.",
  },
  {
    slug: "content-creation",
    label: "Content Creation",
    shortLabel: "CONTENT",
    href: "/services/content-creation",
    description: "Photo, video, and copy produced to your brand system.",
  },
  {
    slug: "ecommerce-solutions",
    label: "E-commerce Solutions",
    shortLabel: "ECOMMERCE",
    href: "/services/ecommerce-solutions",
    description: "Storefronts, checkout, and conversion work that lift revenue.",
  },
] as const;
